function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewAmendmenti = function SvgNewAmendmenti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M19.488 19.53v-6.444a.733.733 0 1 1 1.465 0v6.544c0 .747-.616 1.37-1.393 1.37H4.4a1.383 1.383 0 0 1-1.394-1.37V4.37c0-.747.616-1.37 1.393-1.37h15.16c.778 0 1.394.623 1.394 1.37v1.272c0 .405-.327.735-.732.735s-.733-.33-.733-.735V4.47H4.471v15.062zM17.072 9.116a.73.73 0 0 0-1.037 0l-5.028 5.043a.74.74 0 0 0-.21.44l-.219 1.982c-.023.218.05.434.202.592s.365.238.583.222l1.886-.146a.73.73 0 0 0 .461-.214l5.112-5.125a.736.736 0 0 0 0-1.039zm-4.847 5.9-.093.846.734-.057 4.402-4.415-.715-.715zm5.26-7.37a.74.74 0 0 0 0 1.04l1.767 1.768a.73.73 0 0 0 1.036-.001l.503-.506a.736.736 0 0 0 0-1.038l-1.764-1.77a.73.73 0 0 0-1.037 0z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewAmendmenti);
export default ForwardRef;